import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ISensitivityType } from 'modules/ai-inventory/sensitivy-types/components/BiometricDataStatus';

import React, { useEffect, useState } from 'react';
import { SensitivityService } from 'services/SensitivityService';
import {
  AppFormikSelect,
  AppFormikSelectWithKeys,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const PaperFormCharacteristic: React.FC<PaperFormCharacteristicProps> = (
  props
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('md'));
  const [types, setTypes] = useState<ISensitivityType[]>([]);
  // API Calls

  const loadTypes = (): void => {
    SensitivityService.getAll().then((response) => {
      const { data } = response.data;
      setTypes(data?.sensitivityTypes);
    });
  };

  // Hooks
  useEffect(() => {
    loadTypes();
  }, []);

  // UI Elements
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">Data Characteristic</Typography>
        <Box className="paper-form-input-content">
          <Grid container spacing={4} className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikSelect
                name="sensitivityclass"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="solicitor-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select Data Sensitivity Classification"
                notEmphasized
                notSelectablePlaceholder
                label="Data Sensitivity Classification*"
                items={[
                  'Public',
                  'Internal',
                  'Confidential',
                  'Sensitive',
                  'Restricted',
                ]}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Stack
                className="data-modality"
                direction={match ? 'column' : 'row'}
                spacing={2}
              >
                <Box width="100%" paddingBottom={match ? 2 : 0}>
                  <AppFormikSelect
                    name="datamodalities"
                    className="rework-selection"
                    notched={false}
                    labelId="fix-selection-label"
                    testid="solicitor-dropdown"
                    MenuProps={{
                      className: 'menu-fix-selection single-fix-rework',
                    }}
                    outerLabel
                    multiple
                    placeholder="Add Data Modality"
                    notEmphasized
                    notSelectablePlaceholder
                    label="Data Modalities*"
                    items={[
                      'Tabular',
                      'Images',
                      'Text',
                      'Audio',
                      'Video',
                      'Time Series',
                      'Geospatial',
                      'Other',
                    ]}
                  />
                </Box>
              </Stack>
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="sensitivitytype"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="solicitor-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select  Sensitive Data Types"
                notEmphasized
                notSelectablePlaceholder
                multiple
                valueKey="valueKey"
                titleKey="titleKey"
                label="Sensitive Data Types Present*"
                // items={types.map((t) => t.name)}
                items={types.map((type) => ({
                  valueKey: type.name,
                  titleKey: type.isGlobal ? `${type.name} (Global)` : type.name,
                }))}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Volume/Size"
                placeholder="e.g., 1TB, 1M records"
                name="volumesize"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Data Collection Method"
                placeholder="Enter collection method"
                name="sensitivitycollection"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Geographic Origin"
                placeholder="Enter geographic origin"
                name="geographicorigin"
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                outerLabel
                label="Source Details"
                placeholder="Describe source details"
                name="sourcedetails"
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaperFormCharacteristic;
